import {useBrand} from '@/contexts/BrandContext';
import {usePWA} from '@/hooks/usePWA';
import {SystemUpdateAlt} from '@mui/icons-material';
import {tokens} from '@ark/web';
import {Box, Button, Typography} from '@mui/material';
import {useTheme} from '@mui/material/styles';

export const UpdateAvailableBanner = () => {
  const theme = useTheme();
  const {name: brandName} = useBrand();
  const {updateAvailable, applyUpdate} = usePWA();

  if (!updateAvailable) return null;

  return (
    <Box
      sx={{
        mx: 2,
        mb: 2,
        p: 2,
        borderRadius: `${tokens.radius.lg}px`,
        backgroundColor: theme.palette.info.main,
        color: theme.palette.info.contrastText,
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
      }}
    >
      <SystemUpdateAlt sx={{fontSize: 24, flexShrink: 0}} />
      <Box sx={{flex: 1}}>
        <Typography sx={{fontSize: 14, fontWeight: 600, lineHeight: 1.3}}>
          Update available
        </Typography>
        <Typography sx={{fontSize: 12, opacity: 0.85, lineHeight: 1.3}}>
          A new version of {brandName} is ready
        </Typography>
      </Box>
      <Button
        onClick={applyUpdate}
        variant="contained"
        size="small"
        sx={{
          backgroundColor: 'rgba(255,255,255,0.2)',
          color: 'inherit',
          textTransform: 'none',
          fontWeight: 600,
          fontSize: 13,
          borderRadius: '8px',
          '&:hover': {backgroundColor: 'rgba(255,255,255,0.3)'},
          flexShrink: 0,
        }}
      >
        Refresh
      </Button>
    </Box>
  );
};
